import React, { useState } from 'react';
import { Card, Tag } from 'antd';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './PostCard.css';

function renderTags(tags = []) {
  if (!Array.isArray(tags) || tags.length === 0) return null;
  return (
    <div style={{ marginBottom: 8 }}>
      {tags.map((t) => (
        <Tag key={t}>{t}</Tag>
      ))}
    </div>
  );
}

export default function PostCard({ post, actions, showFull = false }) {
  const [expanded, setExpanded] = useState(!!showFull);
  if (!post) return null;

  // 使用 summary 优先；若 showFull 或展开则展示完整 content
  let preview = '';
  if (post.summary && post.summary.trim() && !expanded && !showFull) preview = post.summary;
  else if (post.content) preview = expanded || showFull ? post.content : post.content.slice(0, 300) + (post.content.length > 300 ? '...' : '');

  const handleToggle = () => setExpanded((v) => !v);

  return (
    <Card
      className="postcard-card"
      title={<div onClick={handleToggle} style={{ cursor: 'pointer', userSelect: 'none' }}>{post.title}</div>}
      style={{ marginBottom: 12 }}
      extra={actions ? <div onClick={(e) => e.stopPropagation()}>{actions}</div> : null}
      onClick={handleToggle}
    >
      {renderTags(post.tags)}
      <div className={`postcard-content ${expanded ? 'expanded' : 'collapsed'}`}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{preview}</ReactMarkdown>
      </div>
      <div className="postcard-meta">作者：{post.authorName} · {new Date(post.createdAt).toLocaleString()}</div>
    </Card>
  );
}
